<template>
  <div id="top-target" class="bill-pay-login__main gds-flex-container">
    <nav class="bill-pay-login__nav">
      <div class="outage-login__nav__inner-link-wrap">
        <router-link to="/login" class="bill-pay-login__nav-item bill-pay-login__nav-item--mobile-button">Login</router-link>
        <router-link to="/login-account" class="bill-pay-login__nav-item bill-pay-login__nav-item--mobile-button">Report with Account Number</router-link>
        <router-link to="/login-phone" class="bill-pay-login__nav-item bill-pay-login__nav-item--mobile-button">Report with Phone Number</router-link>
      </div>
      <div class="bill-pay-login__phone-address-section-desktop">
        <!-- I broke this out to a component so we don't have to have the same code 6 places -->
        <manual-reporting-box />
      </div>
    </nav>

    <div class="bill-pay-login__login-type-container">
      <section class="bill-pay-login__one-time-section">
        <h2 class="bill-pay-login__main-headline gds-display-2">Report an Outage with your Phone Number</h2>
        <p class="gds-body-normal">
          Please enter the phone number associated with your service account. You can also report an outage by
          <router-link to="/login">Logging In</router-link>&nbsp;or by looking up your account by
          <router-link to="/login-account">Account Number</router-link>.
        </p>
        <div v-if="errorWrongNumber" class="form-message-box form-message-box--full-width gds-space-stack-l">
          We were unable to locate an account that matched the information you provided. You can also report an outage by phone at
          <span class="gds-nobreak">{{GMPPhoneNumber}}.</span>
        </div>
        <form class="bill-pay-login__form" @submit.prevent="Login()">
          <fieldset class="gds-fieldset gds-space-stack-m gds-space-inline-default" :class="{ 'gds-has-error': errorWrongNumber }">
            <label class="gds-input-field">
              <span class="gds-input-field__label">Phone Number</span>
              <the-mask
                v-model="phoneNumber"
                :mask="'+1 (###) ###-####'"
                @input.native="touched = true"
                v-validate="'required|min:10'"
                data-vv-validate-on="input"
                name="phone number"
                key="phone number"
                class="gds-input-field__input"
                type="tel"
                placeholder="Your phone number"
              />
            </label>
            <div v-if="errors.first('phone number')" class="validation-error">Complete phone number required</div>
            <div id="captcha-container"></div>
          </fieldset>

          <div class="gds-space-stack-l">
            <div v-if="errorLogin" id="one-time-submission_error" class="gds-helper-text-error">{{errorLogin}}</div>
          </div>

          <div class="gds-space-stack-l">
            <button :disabled="pendingLogin" :class="{ 'gds-loading': pendingLogin }" type="submit" class="gds-button gds-orange">
              <span class="gds-button__text">Next</span>
            </button>
          </div>
        </form>
      </section>
      <section class="bill-pay-login__phone-address-section-mobile">
        <manual-reporting-box />
      </section>
    </div>
  </div>
</template>

<script>
import ManualReportingBox from "./ManualReportingBox";
import { GMPPhoneNumber } from "../../environment"
import { DumpError, ValidateCaptcha } from "../../utilities";

export default {
  name: "ReportOutageLoginPhone",
  components: {
    ManualReportingBox,
  },
  data() {
    return {
      phoneNumber: "",
      errorLogin: undefined,
      errorWrongNumber: undefined,
      pendingLogin: false,
      GMPPhoneNumber,
    };
  },
  computed: {
  },
  async mounted() {
  },
  methods: {
    async Login() {
      if (!await this.$validator.validateAll()) return;

      this.errorLogin = undefined;
      this.errorWrongNumber = false;
      this.pendingLogin = true;
      try {
        // WEB-705 - START
        // To enable captchaToken, swap comments below
        // let captchaToken = await ValidateCaptcha();
        // if(!captchaToken) {
        //   throw { code: 999 };
        // }

        let captchaToken = undefined;
        // WEB-705 - END

        await this.$store.dispatch("LoginPhone", { phoneNumber: this.phoneNumber, captchaToken: captchaToken });
        this.$router.push({ path: "/" });
      } catch (err) {
        DumpError("Phone login error", err);
        if (err.response && err.response.data && err.response.data.errorCode === "NO_DATA_FOUND") {
          this.errorWrongNumber = true;
        }  else if (err.code === 999 || (err.response && err.response.data && err.response.data.code === 15)) {
          this.errorLogin = "Bot detection failed. Please refresh the page and try again. If the problem persists, please contact us.";
        } else {
          this.errorLogin = "There was an error logging in. Please try again later.";
        }
      } finally {
        this.pendingLogin = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>